import { useSearchParams } from 'react-router';

type ParamsUpdate = Record<string, string | null>;

export const useSearchParamsWithUpdate = (): {
  searchParams: URLSearchParams;
  // had to intuit this 👇 from error message, because cursor hates my types
  setSearchParams: (params: URLSearchParams | ((prev: URLSearchParams) => URLSearchParams) | undefined) => void;
  updateParams: (params: ParamsUpdate) => void;
  getMany: (keys: string[], defaultValue: string | null) => (string | null)[];
} => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateParams = (params: ParamsUpdate): void => {
    const newParams = new URLSearchParams(searchParams);
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }
    });
    setSearchParams(newParams);
  };

  const getMany = (keys: string[], defaultValue: string | null = null) => {
    return keys.map((key) => searchParams.get(key) || defaultValue);
  };

  return { searchParams, setSearchParams, updateParams, getMany };
};
